import { Card, CardBody, Image } from "@nextui-org/react";

import { Text } from "@/components/customComponents";

import { PrizeCardProps } from "./types";

const prizeBadgeLogo = "/Assets/prizeBadge.svg";

export default function PrizeCard(props: PrizeCardProps) {
  const { title, description } = props;
  return (
    <Card className="border-1 border-solid border-colorUnderReview overflow-visible bg-gray-200">
      <Image src={prizeBadgeLogo} alt="" className="absolute -top-5 -left-4" />
      <CardBody className="text-center gap-1.5">
        <Text>{title}</Text>
        <Text>{description}</Text>
      </CardBody>
    </Card>
  );
}
